import { mountVueComponent } from '@/lib/mount-vue-component';

export default function() {
  import('@/modules/notifications/components/NotificationList.vue').then(NotificationList => {
    mountVueComponent('notification-list', NotificationList);
  });
}
